import React, {Fragment} from 'react';
import './CashpointsTransactionList.less';
import {ListSplitter} from "elements/list-splitter/ListSplitter.tsx";
import {CashpointsTransaction} from "compositions/cashpoints-transaction/CashpointsTransaction";

export const CashpointsTransactionList = ({transactions}) => {
	return <ul className="cashpoints-transaction-list">
		{
			transactions.map((transaction, index) => <Fragment key={transaction.date}>
				{index > 0 && <ListSplitter isAlignByContainer/>}
				<li className="cashpoints-transaction-list__item">
					<CashpointsTransaction
						date={transaction.createdDate.date}
						amount={transaction.amount}
						type={transaction.type}
					/>
				</li>
			</Fragment>)
		}
	</ul>
}
